export interface SettingsUiState {
  showLanguageOptions: boolean
  showVoiceTypeOptions: boolean
  isManagingSubscription: boolean
  showRemoveAccountDialog: boolean
  removeDialogStep: 'unsubscribe' | 'confirm'
  isCheckingEligibility: boolean
  showEditNameDialog: boolean
  editNameValue: string
  editNameError: string | null
  hasSentVerificationEmail: boolean
}

export type SettingsUiAction =
  | { type: 'setShowLanguageOptions'; value: boolean }
  | { type: 'setShowVoiceTypeOptions'; value: boolean }
  | { type: 'setIsManagingSubscription'; value: boolean }
  | { type: 'setShowRemoveAccountDialog'; value: boolean }
  | { type: 'setRemoveDialogStep'; value: 'unsubscribe' | 'confirm' }
  | { type: 'setIsCheckingEligibility'; value: boolean }
  | { type: 'openEditNameDialog'; value: string }
  | { type: 'closeEditNameDialog' }
  | { type: 'setEditNameValue'; value: string }
  | { type: 'setEditNameError'; value: string | null }
  | { type: 'setHasSentVerificationEmail'; value: boolean }

export const initialSettingsUiState: SettingsUiState = {
  showLanguageOptions: false,
  showVoiceTypeOptions: false,
  isManagingSubscription: false,
  showRemoveAccountDialog: false,
  removeDialogStep: 'confirm',
  isCheckingEligibility: false,
  showEditNameDialog: false,
  editNameValue: '',
  editNameError: null,
  hasSentVerificationEmail: false,
}

export function settingsUiReducer(
  state: SettingsUiState,
  action: SettingsUiAction,
): SettingsUiState {
  switch (action.type) {
    case 'setShowLanguageOptions':
      return { ...state, showLanguageOptions: action.value }
    case 'setShowVoiceTypeOptions':
      return { ...state, showVoiceTypeOptions: action.value }
    case 'setIsManagingSubscription':
      return { ...state, isManagingSubscription: action.value }
    case 'setShowRemoveAccountDialog':
      return { ...state, showRemoveAccountDialog: action.value }
    case 'setRemoveDialogStep':
      return { ...state, removeDialogStep: action.value }
    case 'setIsCheckingEligibility':
      return { ...state, isCheckingEligibility: action.value }
    case 'openEditNameDialog':
      return {
        ...state,
        showEditNameDialog: true,
        editNameValue: action.value,
        editNameError: null,
      }
    case 'closeEditNameDialog':
      return {
        ...state,
        showEditNameDialog: false,
        editNameValue: '',
        editNameError: null,
      }
    case 'setEditNameValue':
      return { ...state, editNameValue: action.value, editNameError: null }
    case 'setEditNameError':
      return { ...state, editNameError: action.value }
    case 'setHasSentVerificationEmail':
      return { ...state, hasSentVerificationEmail: action.value }
    default:
      return state
  }
}
